// import React, { useState } from "react"
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  //   Button,
  Paper,
  Box,
  Typography,
} from "@mui/material"
// import { useNavigate } from "react-router-dom"
// import { SCREENS_DETAILS } from "../../../util/StaticData"
// import { sampleMappedData } from "../dataset/static"
import { useAppDispatch, useAppSelector } from "../../../util/hooks"
import { selectAllForApproval, setSelectedForApproval } from "./MapSlice"
import { useEffect } from "react"

interface ISummaryData {
  name: string
  rows: number
  volume_uc: number
  status: number
  approval_completion: number
}

export interface ISampleData {
  country_l: string
  category_l: string
  brand_l: string
  vol_l: number
  country_r: string
  category_r: string
  brand_r: string
  vol_r: number
  approval_status?: string
  match_status: string
  mapping_accuracy: string
  status: number
  id: number
  similarity:number
}

const getBackgroundStatusColor = (status: ISummaryData["status"]) => {
  switch (status) {
    case 1:
      return "status.green"
    case 2:
      return "status.neutral"
    case 3:
      return "status.yellow"
    default:
      return "status.red"
  }
}





const getStatusTextColor = (status: ISummaryData["status"]) => {
  if (status === 2) {
    return "textColors.grey2"
  } else return "white"
}

const getStatus = (status: ISummaryData["status"]) => {
  switch (status) {
    case 0:
      return "Rejected"
    case 1:
      return "Approved"
    case 2:
      return "Yet to Approve"
    case 3:
      return "In Progress"
    default:
      return ""
  }
}

const MapInsightsTable = ({ activeTab }: { activeTab: string }) => {
  const dispatch = useAppDispatch()
  const {
    mappedData,
    selectedForApproval,
    absoluteMapped,
    approximateMapped,
    notMapped,
    filter,
  } = useAppSelector((state) => state.map)

  const isSelectedAll = () => {
    return tabWiseFilteredData.length === selectedForApproval.length
  }
  useEffect(()=>{
    if(mappedData){
      console.log("insight mapped data",mappedData)
      // console.log("insight tabWiseFilteredData data",tabWiseFilteredData)
      tabWiseFilteredData
    }
  },[mappedData])
  const handleSelectAll = () => {
    if (isSelectedAll()) {
      dispatch(selectAllForApproval([]))
    } else {
      dispatch(selectAllForApproval(tabWiseFilteredData.map((data) => data.id)))
    }
  }

  const handleSelectForApproval = (id: number) => {
    dispatch(setSelectedForApproval(id))
  }

  const tabWiseFilteredData = (
    activeTab === "All"
      ? mappedData
      : activeTab === "Absolute Mapped"
      ? absoluteMapped
      : activeTab === "Approximate Mapped"
      ? approximateMapped
      : notMapped
  ).filter((data) => {
    const dynSelected = filter.dynamicSelected || {}
    const keyMap = filter.dynamicKeyToRowKey || {}
    for (const [compositeKey, selectedValues] of Object.entries(dynSelected)) {
      if (!selectedValues || selectedValues.length === 0) continue
      const rowKey = (keyMap as any)[compositeKey] || compositeKey
      const cell = (data as any)[rowKey]
      if (!selectedValues.includes(cell)) return false
    }
    return true
  })


  // Derive dynamic columns from data keys (generic)
  const sampleRow = tabWiseFilteredData[0] || mappedData[0]
  console.log("[MI] sampleRow exists:", !!sampleRow)
  console.log("[MI] tabWiseFilteredData length:", tabWiseFilteredData.length)
  console.log("[MI] mappedData length:", mappedData.length)
  console.log("[MI] tabWiseFilteredData (first row):", tabWiseFilteredData[0])
  console.log("[MI] mappedData (first row):", mappedData[0])

  const allKeysRaw = sampleRow ? Object.keys(sampleRow as any) : []
  console.log("[MI] allKeysRaw:", allKeysRaw)
  const excluded = new Set(["id", "status", "similarity", "approval_status", "match_status"])
  const allKeys = allKeysRaw.filter((k) => !excluded.has(k))
  console.log("[MI] allKeys (excluded meta):", allKeys)

  const hasSuffixKeys = allKeys.some((k) => /_[lr]$/.test(k))
  console.log("[MI] hasSuffixKeys:", hasSuffixKeys)

  let leftKeys: string[] = []
  let rightKeys: string[] = []

  const normalize = (s: string) => String(s).toLowerCase().replace(/[^a-z0-9]/g, "")

  const findKeysForLabels = (labels: string[], prefer: "l" | "r") => {
    const used = new Set<string>()
    const picked: string[] = []
    labels.forEach((label) => {
      const n = normalize(label)
      const candidate = allKeys.find((k) => {
        if (used.has(k)) return false
        const nk = normalize(k.replace(/_[lr]$/, ""))
        return nk === n || nk === `${n}${prefer}` || nk === n
      })
      if (candidate) {
        used.add(candidate)
        picked.push(candidate)
      }
    })
    // fallback: add remaining keys in order
    allKeys.forEach((k) => {
      if (picked.length >= labels.length) return
      if (!used.has(k)) {
        used.add(k)
        picked.push(k)
      }
    })
    return picked
  }

  const { dataset1, dataset2 } = useAppSelector((state) => state.harmonization)
  const dataset1Name = dataset1?.selectedDataset || "Dataset 1"
  const dataset2Name = dataset2?.selectedDataset || "Dataset 2"

  if (hasSuffixKeys) {
    leftKeys = allKeys.filter((k) => k.endsWith("_l"))
    rightKeys = allKeys.filter((k) => k.endsWith("_r"))
  } else {
    // Preserve order: left strictly follows dataset1.selectedColumns order; right strictly follows dataset2.selectedColumns order; then append remaining in original order to right
    const ds1Cols = dataset1?.selectedColumns || []
    const ds2Cols = dataset2?.selectedColumns || []

    const used = new Set<string>()
    const pickByLabels = (labels: string[]) => {
      const picked: string[] = []
      labels.forEach((label) => {
        const found = allKeys.find(
          (k) => !used.has(k) && k.replace(/_[lr]$/, "").toLowerCase() === label.toLowerCase(),
        )
        if (found) {
          used.add(found)
          picked.push(found)
        }
      })
      return picked
    }

    const leftPicked = ds1Cols.length ? pickByLabels(ds1Cols) : []
    const rightPicked = ds2Cols.length ? pickByLabels(ds2Cols) : []

    const remainingKeys = allKeys.filter((k) => !used.has(k))

    if (leftPicked.length === 0 && rightPicked.length === 0) {
      const mid = Math.floor(allKeys.length / 2)
      leftKeys = allKeys.slice(0, mid)
      rightKeys = allKeys.slice(mid)
    } else {
      leftKeys = leftPicked
      rightKeys = [...rightPicked, ...remainingKeys]
    }
  }
  console.log("[MI] leftKeys:", leftKeys)
  console.log("[MI] rightKeys:", rightKeys)

  const leftLabels = leftKeys.map((k) => {
    const base = k.replace(/_[lr]$/, "")
    const match = dataset1?.selectedColumns?.find(
      (c) => c.toLowerCase() === base.toLowerCase(),
    )
    return match || base
  })

  const rightLabels = rightKeys.map((k) => {
    const base = k.replace(/_[lr]$/, "")
    const match = dataset2?.selectedColumns?.find(
      (c) => c.toLowerCase() === base.toLowerCase(),
    )
    return match || base
  })
  console.log("[MI] leftLabels:", leftLabels)
  console.log("[MI] rightLabels:", rightLabels)

  return (
    <TableContainer
      className="custom-scrollbar2"
      component={Paper}
      sx={{ boxShadow: "none", pb: 2 ,height:'300px', overflowY:'auto'}}
    >
      <Table
        sx={{ "& th, td": { fontSize: "11px", border: "none", py: 1 } }}
        aria-label="summary table"
      >
        <TableHead>
          <TableRow sx={{}}>
            <TableCell
              colSpan={1 + Math.max(1, leftKeys.length)}
              sx={{
                textAlign: "center",
                fontWeight: 700,
                borderTopRightRadius: "4px",
                backgroundColor: "#CCCCCC",
              }}
            >
              {dataset1Name}
            </TableCell>

            <TableCell
              colSpan={Math.max(1, rightKeys.length)}
              sx={{
                textAlign: "center",
                fontWeight: 700,
                borderTopLeftRadius: "4px",
                borderTopRightRadius: "4px",
                backgroundColor: "#979797",
              }}
            >
              {dataset2Name}
            </TableCell>

            <TableCell
              colSpan={1}
              sx={{
                textAlign: "center",
                fontWeight: 700,
                backgroundColor: "#93CCCA",
                borderTopLeftRadius: "4px",
              }}
            ></TableCell>
          </TableRow>

          <TableRow sx={{ backgroundColor: "#E2E2E2" }}>
            <TableCell sx={{ width: "0" }}>
              <Checkbox
                checked={isSelectedAll()}
                onChange={handleSelectAll}
                sx={{
                  p: 0,
                  "& .MuiSvgIcon-root": { fontSize: 15, cursor: "default" },
                }}
                size="small"
              />
            </TableCell>
            {(leftLabels.length ? leftLabels : ["Column 1"]).map((label, i) => (
            <TableCell
                key={`left-head-${i}`}
              align="left"
              sx={{ fontWeight: 700, whiteSpace: "nowrap" }}
            >
                {label}
            </TableCell>
            ))}

            {(rightLabels.length ? rightLabels : ["Column 1"]).map((label, i) => (
            <TableCell
                key={`right-head-${i}`}
              align="left"
              sx={{
                fontWeight: 700,
                backgroundColor: "#C8C8C8",
                whiteSpace: "nowrap",
              }}
            >
                {label}
            </TableCell>
            ))}

            <TableCell
              sx={{
                fontWeight: 700,
                backgroundColor: "#93CCCA",
                whiteSpace: "nowrap",
              }}
            >
              Approval Status
            </TableCell>
            {/* <TableCell
              sx={{
                fontWeight: 700,
                backgroundColor: "#93CCCA",
                whiteSpace: "nowrap",
              }}
            >
              Mapping Accuracy
            </TableCell> */}
          </TableRow>
        </TableHead>

        <TableBody>
          {tabWiseFilteredData.map((row, index) => (
            <TableRow sx={{ backgroundColor: "textColors.grey3" }} key={index}>
              <TableCell sx={{ width: "fit-content" }}>
                <Checkbox
                  checked={selectedForApproval.includes(row.id)}
                  onChange={() => handleSelectForApproval(row.id)}
                  sx={{
                    p: 0,
                    "& .MuiSvgIcon-root": { fontSize: 15, cursor: "default" },
                  }}
                  size="small"
                />
              </TableCell>
              {(leftKeys.length ? leftKeys : [allKeys[0]]).map((k) => (
                <TableCell key={`left-cell-${k}-${index}`} align="left">
                  {(row as any)[k]}
                </TableCell>
              ))}

              {(rightKeys.length ? rightKeys : allKeys.filter((k) => k !== (leftKeys[0] || allKeys[0]))).map((k) => (
                <TableCell
                  key={`right-cell-${k}-${index}`}
                  align="left"
                  sx={{ backgroundColor: "#D5D5D5" }}
                >
                  {(row as any)[k]}
              </TableCell>
              ))}

              <TableCell align="center" sx={{ backgroundColor: "#2FD4CF33" }}>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Typography
                    sx={{
                      backgroundColor: getBackgroundStatusColor(row.status),
                      color: getStatusTextColor(row.status),
                      fontSize: 11,
                      py: "2px",
                      px: "2px",
                      width: "fit-content",
                    }}
                  >
                    {getStatus(row.status)}
                  </Typography>
                </Box>
              </TableCell>
              {/* <TableCell align="center" sx={{ backgroundColor: "#2FD4CF33" }}>
                {row.mapping_accuracy}
              </TableCell> */}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default MapInsightsTable
